let isListening = false;
let cards = [];

export const productionsParallax = () => {
  cards = Array.from(document.querySelectorAll('.c-project'));

  if (cards.length === 0) {
    return;
  }

  const isTouchDevice = 'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch);
  if (isTouchDevice) {
    return;
  }

  const applyTransform = (card, media) => {
    const scrollOffset = parseFloat(card.dataset.scrollOffset || '0');
    const hoverX = parseFloat(card.dataset.hoverX || '0');
    const hoverY = parseFloat(card.dataset.hoverY || '0');
    media.style.transform = `translate3d(${hoverX}px, ${scrollOffset + hoverY}px, 0)`;
  };

  const handleScroll = () => {
    const windowHeight = window.innerHeight;

    cards.forEach((card) => {
      const media = card.querySelector('.c-project__media');
      if (!media) {
        return;
      }

      const rect = card.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= windowHeight) {
        card.dataset.scrollOffset = '0';
        applyTransform(card, media);
        return;
      }

      const progress = (windowHeight - rect.top) / (windowHeight + rect.height);
      const offset = (progress - 0.5) * rect.height * 0.35;
      card.dataset.scrollOffset = offset.toString();
      applyTransform(card, media);
    });
  };

  let ticking = false;
  const throttled = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  };

  if (!isListening) {
    window.addEventListener('scroll', throttled, { passive: true });
    window.addEventListener('resize', throttled);
    isListening = true;
  }

  handleScroll();
};
